<template>
  <div class="NoResults Block">
    <div
      v-if="textSearch.length"
      class="Notice Notice--warning"
    >
      <p>Your search for <strong>{{ textSearch }}</strong> did not match any results.</p>

      <p>You could try:</p>
      <ul class="NoResults-suggestions">
        <li>Choosing options suggested in the autocomplete field above</li>
        <li>Searching using more general keywords</li>
        <li>Consider using filters instead of using a text search</li>
      </ul>
    </div>

    <div
      v-else
      class="Notice Notice--warning"
    >
      <p>We couldn't find any results that matched your search.</p>
    </div>

    <div v-if="searchType === 'companies'">
      <h3>We might be able to still help if you select what industry the company you are looking for works in:</h3>

      <ul class="JobIndustries">
        <li
          v-for="suggestion in disciplinesSuggestions"
          :key="suggestion.url"
        >
          <a :href="suggestion.url">{{ suggestion.name }}</a>
        </li>
      </ul>
    </div>
    <div v-else>
      <h3 v-if="searchType === 'jobs'">
        We might be able to still help if you select what sort of role you are looking for below:
      </h3>
      <h3 v-else>
        We might be able to still help if you select what industry the reviews you are looking for fall into:
      </h3>

      <ul class="JobIndustries">
        <li
          v-for="suggestion in jobTypeSuggestions"
          :key="suggestion.url"
        >
          <a :href="suggestion.url">{{ suggestion.name }}</a>
        </li>
      </ul>
    </div>

    <div v-if="searchType === 'jobs'">
      <h3>Have a look at our reviews</h3>
      <p>Can't find the job you're looking for consider seeing what reviews we have for your search.</p>
      <p><a href="/search-reviews">View Reviews &rarr;</a></p>
    </div>

    <register-email-only
      import-comment="Search - no results"
      heading="Get personalised jobs straight to your inbox"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import RegisterEmailOnly from '../../authentication/register-touch-points/register-email-only.vue';

export default {
  name: 'SearchNoResults',

  components: {
    RegisterEmailOnly,
  },

  computed: {
    ...mapState('search', {
      filters: (state) => state.filters,
      searchType: (state) => state.query.show,
      textSearch: (state) => state.query.s,
    }),

    jobTypeSuggestions() {
      if (!this.filters.programme) {
        return [];
      }

      return this.filters.programme.map((filter) => {
        return {
          url: `/search-${this.searchType}/${filter.key}`,
          name: filter.name,
        };
      });
    },

    disciplinesSuggestions() {
      if (!this.filters.discipline) {
        return [];
      }

      return this.filters.discipline.map((filter) => {
        return {
          url: `/search-${this.searchType}/all-types/${filter.key}`,
          name: filter.name,
        };
      });
    },
  },

  mounted() {
    this.$gtag.send({
      event: 'no-results',
      action: 'page-load',
      category: 'search',
    });
  },

  methods: {
    ...mapMutations('search', {
      updateQueryFilters: 'updateQueryFilters',
    }),

    removeTextSearch() {
      this.updateQueryFilters({
        filterValues: '',
        filterName: 's',
      });
    },
  },
};
</script>
